let e;!function(e){e.zhCN="zh-CN",e.zhTW="zh-TW",e.enUS="en-US"}(e||(e={}));export{e as ELocaleLang};
